import React, { useContext } from "react"
import { UserContext } from "../../context/userContext"
import StaffProfilePhoto from "../../components/StaffProfilePhoto"
import { Link } from "react-router-dom"
import _ from "lodash"
import classNames from "classnames"
import {
  isEnterpriseAdmin,
  PARTNER_ADMIN_ROLE,
} from "../../helpers/staffRoleHelpers"

import styles from "../../styles/StaffProfileMenu.module.css"

export default function StaffProfileMenu({
  profileMenuRef,
  toggles,
  setToggles,
  currentStaffMembership,
  staffAdminMembershipOrg,
  organizationName,
  firebase,
}) {
  const userCtx = useContext(UserContext)

  return (
    <div className="profile-menu" ref={profileMenuRef}>
      <div
        className="profile-menu-trigger"
        id="profile-menu-trigger"
        onClick={() =>
          setToggles((prev) => ({ ...prev, profile: !prev.profile }))
        }
      >
        <StaffProfilePhoto
          staff_profile_image={userCtx.session.user.staff_profile_image}
          className="border-2 border-white rounded-full w-11 h-11"
        />
        <div className={classNames("summary", styles.profileSummary)}>
          <span className={styles.profileSummaryLine}>
            {_.unescape(userCtx.session.user.staff_name_first)}{" "}
            {_.unescape(userCtx.session.user.staff_name_last)}
          </span>
          <span className={styles.profileSummaryLine}>
            {userCtx.session.user.staff_description}
          </span>
          <span className={styles.profileSummaryLine}>
            {_.unescape(organizationName)}
          </span>
        </div>
      </div>

      <ul
        id="top-main-menu"
        className={classNames(
          "top-menu-dropdown-profile",
          styles.profileMenuPopup,
          {
            active: toggles.profile,
          },
        )}
      >
        {userCtx.session.user.staff_role < PARTNER_ADMIN_ROLE && (
          <>
            {toggles.organizationMembership && (
              <li
                className={classNames("top-dropdown-option", styles.profileMenuOption)}
                onClick={() =>
                  userCtx.setToggleAppointments({
                    toggle: true,
                    page: "availability",
                  })
                }
              >
                <span className="material-icons">calendar_month</span>
                <label>My Availability</label>
              </li>
            )}
            {toggles.organizationMembership && (
              <li className={classNames("top-dropdown-option", styles.profileMenuOption)}>
                <Link
                  className={styles.profileMenuOptionLink}
                  to="/organization/staff/profile"
                  onClick={() =>
                    userCtx.changeCurrentStaffMembershipId(
                      currentStaffMembership,
                    )
                  }
                >
                  <span className="material-icons">fact_check</span>
                  <label>Staff Member profile</label>
                </Link>
              </li>
            )}
          </>
        )}
        <li className={classNames("top-dropdown-option", styles.profileMenuOption)}>
          <Link className={styles.profileMenuOptionLink} to="account/2fa/settings">
            <span className="material-icons"> key </span>
            <label>2FA Settings</label>
          </Link>
        </li>
        <li className={classNames("top-dropdown-option", styles.profileMenuOption)}>
          <Link
            className={styles.profileMenuOptionLink}
            to={`/form/account_preferences/1/${userCtx.session.user.staff_id_stamp}`}
            onClick={() => {
              if (isEnterpriseAdmin(userCtx.session.user.staff_role, true)) {
                userCtx.changeOrganization(staffAdminMembershipOrg)
                userCtx.changeCurrentStaffMembershipId(
                  userCtx.session.user.staff_membership_id,
                )
              } else {
                userCtx.changeCurrentStaffMembershipId(currentStaffMembership)
              }
            }}
          >
            <span className="material-icons"> manage_accounts </span>
            <label>Account Preferences</label>
          </Link>
        </li>

        <hr className={styles.profileMenuSeparator} />

        <li
          className={classNames("top-dropdown-option", styles.profileMenuOption)}
          onClick={() => {
            firebase.signOut()
          }}
        >
          <span className="material-icons"> logout </span>
          <label>Logout</label>
        </li>
      </ul>
    </div>
  )
}
